export function insertNonBreakingSpaces(
  text: string | null,
  html = true
): string | null {
  if (text == null) return text;
  const NBSP_CHAR = "\u00A0";
  const NBSP_HTML = "&nbsp;";
  const NBSP = html ? NBSP_HTML : NBSP_CHAR;
  const prepositions = [
    "а-ля",
    "без",
    "без ведома",
    "безо",
    "безъ",
    "благодаря",
    "близ",
    "близко от",
    "близь",
    "в",
    "в виде",
    "в зависимости от",
    "в интересах",
    "в качестве",
    "в лице",
    "в отношении",
    "в пандан",
    "в пользу",
    "в преддверии",
    "в продолжение",
    "в результате",
    "в роли",
    "в связи с",
    "в силу",
    "в случае",
    "в соответствии с",
    "в течение",
    "в целях",
    "в честь",
    "в/на",
    "вблизи",
    "ввиду",
    "вглубь",
    "вдогон",
    "вдоль",
    "вдоль по",
    "взамен",
    "включая",
    "вкруг",
    "вместо",
    "вне",
    "внизу",
    "внутри",
    "внутрь",
    "во",
    "во имя",
    "во славу",
    "вовнутрь",
    "возле",
    "вокруг",
    "вопреки",
    "вослед",
    "впереди",
    "вплоть до",
    "впредь до",
    "вразрез",
    "вроде",
    "вслед",
    "вслед за",
    "вследствие",
    "встречу",
    "выключая",
    "выше",
    "дли",
    "для",
    "для-ради",
    "до",
    "за",
    "за вычетом",
    "за исключением",
    "за счёт",
    "за-ради",
    "замест",
    "заместо",
    "и",
    "из",
    "из-за",
    "из-под",
    "из-подо",
    "изнутри",
    "изо",
    "исключая",
    "исходя из",
    "к",
    "касаемо",
    "касательно",
    "ко",
    "кончая",
    "кроме",
    "кругом",
    "лицом к лицу с",
    "меж",
    "между",
    "мимо",
    "на",
    "на благо",
    "на виду у",
    "на глазах у",
    "на предмет",
    "наверху",
    "навроде",
    "навстречу",
    "над",
    "надо",
    "назад",
    "назади",
    "назло",
    "накануне",
    "наместо",
    "наперекор",
    "наперерез",
    "наперехват",
    "наподобие",
    "наподобье",
    "напротив",
    "наряду с",
    "насупротив",
    "насчёт",
    "начиная с",
    "не без",
    "не считая",
    "невзирая на",
    "недалеко от",
    "независимо от",
    "несмотря",
    "несмотря на",
    "ниже",
    "о",
    "об",
    "обо",
    "обок",
    "обочь",
    "около",
    "окрест",
    "окроме",
    "окромя",
    "округ",
    "опосля",
    "опричь",
    "от",
    "от имени",
    "от лица",
    "относительно",
    "ото",
    "перед",
    "передо",
    "по",
    "по линии",
    "по мере",
    "по направлению к",
    "по отношению к",
    "по поводу",
    "по причине",
    "по случаю",
    "по сравнению с",
    "по-за",
    "по-над",
    "по-под",
    "поблизости от",
    "повдоль",
    "поверх",
    "под",
    "под видом",
    "под эгидой",
    "подле",
    "подо",
    "подобно",
    "позади",
    "позадь",
    "позднее",
    "помимо",
    "поперёг",
    "поперёд",
    "поперёк",
    "порядка",
    "посверху",
    "посереди",
    "посередине",
    "посерёдке",
    "посередь",
    "после",
    "посреди",
    "посредине",
    "посредством",
    "пред",
    "предо",
    "преж",
    "прежде",
    "при",
    "при помощи",
    "применительно к",
    "про",
    "промеж",
    "промежду",
    "против",
    "противно",
    "противу",
    "путём",
    "ради",
    "рядом с",
    "с",
    "с ведома",
    "с помощью",
    "с прицелом на",
    "с точки зрения",
    "с целью",
    "сбоку",
    "сверх",
    "сверху",
    "свыше",
    "середи",
    "середь",
    "сзади",
    "сквозь",
    "скрозь",
    "следом за",
    "смотря по",
    "снизу",
    "со",
    "согласно",
    "соответственно",
    "сопротив",
    "спустя",
    "среди",
    "средь",
    "сродни",
    "судя по",
    "супротив",
    "у",
    "через",
    "черезо",
    "чрез",
    "чрезо"
  ];
  const escapeRegex = (s: string): string =>
    s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const preps = prepositions
    .slice()
    .sort((a, b) => b.length - a.length)
    .map(escapeRegex);

  const re = new RegExp(
    `(^|[^A-Za-zА-Яа-яЁё0-9])(${preps.join("|")})\\s+`,
    "gi"
  );

  text = text
    .replace(re, (m, left, prep) => left + prep + NBSP)
    .replace(/(\d) (\d)/g, (m, a, b) => a + NBSP + b)
    .replace(/(\d+)\s+([₽$€¥₸])/g, (m, a, b) => a + NBSP + b)
    .replace(new RegExp("," + NBSP, "g"), ", ");

  return text;
}
